import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  connectionStatus: "idle",
  reconnectAttempts: 0,
  pendingAnswersCount: 0,
  connectionMessage: null,
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    wsConnecting(state) {
      state.connectionStatus = "connecting";
    },
    wsConnected(state) {
      state.connectionStatus = "connected";
      state.reconnectAttempts = 0;
    },
    wsDisconnected(state) {
      state.connectionStatus = "disconnected";
      state.reconnectAttempts += 1;
    },
    wsError(state, action) {
      state.connectionStatus = "error";
      state.connectionMessage = action.payload;
    },
    setReconnectAttempts(state, action) {
      state.reconnectAttempts = action.payload;
    },
    setPendingAnswersCount(state, action) {
      state.pendingAnswersCount = action.payload;
    },
  },
});

export const {
  wsConnecting,
  wsConnected,
  wsDisconnected,
  wsError,
  setReconnectAttempts,
  setPendingAnswersCount,
} = websocketSlice.actions;

export default websocketSlice.reducer;